import { Link } from 'react-router';
import { BookOpen, Mail, MessageSquare } from 'lucide-react';
import { UniversalPage, Card, Button } from '@afrilink/ui';
import { siteConfig } from '@afrilink/config';

/**
 * Knowledgebase placeholder.
 *
 * Articles + search ship in Phase 9 once the editorial pass is complete.
 * For now, route customers to the most useful self-service paths and
 * make it trivial to open a ticket.
 */
export default function KnowledgebasePage() {
  return (
    <UniversalPage
      title="Knowledgebase"
      description="Articles and guides for hosting and domains."
      breadcrumbs={[
        { label: 'Home', href: '/app' },
        { label: 'Support', href: '/app/support' },
        { label: 'Knowledgebase' },
      ]}
    >
      <div className="grid grid-cols-1 gap-6 md:grid-cols-2">
        <Card interactive={false} className="p-6">
          <div className="mb-3 inline-flex items-center gap-2 text-primary">
            <BookOpen className="size-5" aria-hidden />
            <h3 className="text-base font-semibold text-navy-primary">Articles coming soon</h3>
          </div>
          <p className="text-sm text-muted-foreground">
            We're writing setup guides for cPanel, email, and domain transfers.
            They'll appear here once published — no action needed on your part.
          </p>
        </Card>

        <Card interactive={false} className="p-6">
          <div className="mb-3 inline-flex items-center gap-2 text-primary">
            <MessageSquare className="size-5" aria-hidden />
            <h3 className="text-base font-semibold text-navy-primary">Need help today?</h3>
          </div>
          <p className="mb-4 text-sm text-muted-foreground">
            Our support team replies within one business day. Open a ticket
            with the details, or email us directly.
          </p>
          <div className="flex flex-wrap gap-2">
            <Button asChild size="sm">
              <Link to="/app/support/new">Open a ticket</Link>
            </Button>
            <Button asChild size="sm" variant="outline">
              <a href={`mailto:${siteConfig.supportEmail}`}>
                <Mail className="size-4" />
                {siteConfig.supportEmail}
              </a>
            </Button>
          </div>
        </Card>
      </div>
    </UniversalPage>
  );
}
